import {createStyles} from '@mantine/core';
import React from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import * as Colors from 'ui-library/Colors';

const ENTITY_MAP_BETA_FEEDBACK_FORM =
  'https://docs.google.com/forms/d/e/1FAIpQLScYMHegJEgz3DsY1pl2T7E-CUYlJhOxtmmjllWPtyY5c16y_A/viewform';

const useStyles = createStyles(() => ({
  container: {
    borderRadius: 4,
    boxShadow: `0px 2px 8px 2px ${Colors.GRAY_LIGHT}`,
    position: 'absolute',
    marginLeft: 20,
    marginTop: 20,
    zIndex: 10,
  },
}));

/**
 * Render a banner for soliciting beta feedback for the entity map feature.
 */
export default function EntityMapBetaBanner(): JSX.Element {
  const {classes} = useStyles();

  return (
    <div className={classes.container}>
      <InlineBanner
        bannerType={InlineBannerType.BETA}
        hideIcon={true}
        text={
          <>
            <a href={ENTITY_MAP_BETA_FEEDBACK_FORM} target="_blank" rel="noreferrer">
              Share feedback
            </a>
          </>
        }
      />
    </div>
  );
}
